<template>
    <div>
        <b-dropdown
            dropleft
            right
            size="xs"
        >
            <template slot="button-content">
                <i class="fa fa-caret-down" />
            </template>

            <b-dropdown-header>Group actions</b-dropdown-header>

            <b-dropdown-item @click="addCostToGroup">
                <i class="fa fa-fw fa-plus" />
                <span class="ml-2">Add cost</span>
            </b-dropdown-item>

            <b-dropdown-item
                v-if="canBeAddedToTab"
                @click="addToTab"
            >
                <i class="fa fa-fw fa-arrow-right" />
                <span class="ml-2">Add to tab</span>
            </b-dropdown-item>

            <b-dropdown-item @click="renameGroup">
                <i class="fa fa-fw fa-pencil" />
                <span class="ml-2">Rename</span>
            </b-dropdown-item>

            <b-dropdown-item @click="duplicateGroup">
                <i class="fa fa-fw fa-clone" />
                <span class="ml-2">Duplicate</span>
            </b-dropdown-item>

            <b-dropdown-item @click="deleteGroup">
                <i class="fa fa-fw fa-trash" />
                <span class="ml-2">Delete</span>
            </b-dropdown-item>

        </b-dropdown>
    </div>
</template>

<script>
export default {

    props: {
        group: {
            type: Object,
            required: true,
        },
    },

    computed: {
        canBeAddedToTab() {
            return !!this.group.id && this.$store.getters['costable/areTabsEnabled'];
        },
    },

    methods: {
        deleteGroup() {
            this.$eventBus.$emit(this.$events.openConfirmationModal, {
                title: `Delete group - ${this.group.name}`,
                body: 'Are you sure you want to delete this group?',
                submitButtonVariant: 'danger',
                onSubmit: () => {
                    this.$store.dispatch('costable/deleteGroup', this.group.id);
                },
            });
        },
        renameGroup() {
            this.$eventBus.$emit(this.$events.openRenameModal, {
                title: `Rename group - ${this.group.name}`,
                name: this.group.name,
                description: this.group.description,
                onSubmit: (name, description) => {
                    this.$store.dispatch('costable/renameGroup', {
                        groupId: this.group.id,
                        name,
                        description,
                    });
                },
            });
        },
        duplicateGroup() {
            this.$eventBus.$emit(this.$events.openConfirmationModal, {
                title: `Duplicate group - ${this.group.name}`,
                body: 'Are you sure you want to duplicate this group?',
                onSubmit: () => {
                    this.$store.dispatch('costable/duplicateGroup', this.group.id);
                },
            });
        },
        addCostToGroup() {
            this.$eventBus.$emit(this.$events.openAddCostModal, {
                groupId: this.group.id,
            });
        },
        addToTab() {
            this.$eventBus.$emit(this.$events.openAddToTabModal, {
                title: 'Add group to tab',
                groupId: this.group.id,
            });
        },
    },

};
</script>
